<template>
    <div>
        <h2 id="personal-title" class='h1 text-secondary'>{{ section.name }}</h2>

        <h3 class="h2 text-success mt-5 mb-3">Langues</h3>

        <ul class="mt-3" style="font-size:1.2rem; line-height:2rem; color:#555;">
            <li v-for="(lang, langIdx) in datas.personal.languages" :key="'lang_' + langIdx">
                <span class='text-secondary'>{{ lang.lang }} : </span>
                <span class='text-primary'>{{ lang.level }}</span>
            </li>
        </ul>

        <h3 class="h2 text-success mt-5 mb-3">Centres d'intérêt</h3>

        <p v-for="(interest, interestIdx) in datas.personal.interests" :key="'interest_' + interestIdx">
            <i class="text-secondary bi me-2" :class="interest.icon" ></i>
            <span class='text-primary'>{{ interest.name }}</span>
        </p>

    </div>
</template>

<script>
export default {
    // name
    name: 'SectionPersonal',
    // components
    components: {
    },
    // props
    props : {
        section : { type : Object, required : true }
    },
    // data
    data : function() {
        return {

        }
    },
    mounted : function() {

    },
    methods : {

    },
    computed : {
    }
}
</script>

<style scoped>
</style>
